import controller from './account.controller';
import templateBase from './templates/account-base.view.html';
import templateT15 from './templates/account-t15.view.html';
import templateAD from './templates/account-adaptative.html';

let AccountComponent = {
  template: changeTemplate,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
  let response = SessionService.get('components');

  if(__env.adaptative) {
      return templateAD;
  } else {
    if (response.ACCOUNT.component == 'template_t15') { return templateT15; }
    else {
      return templateBase;
    }
  }
}

export default AccountComponent;


// WEBPACK FOOTER //
// ./www/components/account/account.component.js